import { render, staticRenderFns } from "./Gbm-Footer.vue?vue&type=template&id=ab99cefc&"
import script from "./Gbm-Footer.vue?vue&type=script&lang=js&"
export * from "./Gbm-Footer.vue?vue&type=script&lang=js&"
import style0 from "./Gbm-Footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Gbm-Footer.vue"
export default component.exports